import { Tax } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const TAX_FIND = createAction('[Tax] Find');
export const TAX_FIND_SUCCESS = createAction('[Tax] Find Success', props<{ tax: Tax[] }>());
export const TAX_FAILED = createAction('[Tax] Failed', props<{ error: string }>());
export const TAX_UPDATE_LOADING = createAction('[Tax] Update Loading', props<{ loading: boolean }>());
export const TAX_UPDATE_ID = createAction('[Tax] Update Id', props<{ taxId: string }>());

